import { isPrimitive, stableStringify } from 'utils/common';

import { useEffect } from 'react';

function checkDeps(deps) {
  if (!deps || !deps.length) {
    throw new Error(
      'useStableCompareEffect should not be used with no dependencies. Use React.useEffect instead.'
    );
  }
}

function stabilizeDependencies(deps: ReadonlyArray<unknown>) {
  return deps.map((dep) => (isPrimitive(dep) ? dep : stableStringify(dep)));
}

export function useStableCompareEffect(
  callback: () => void | (() => void | undefined),
  deps: ReadonlyArray<unknown>
): void {
  if (process.env.NODE_ENV !== 'production') {
    checkDeps(deps);
  }
  useEffect(callback, stabilizeDependencies(deps));
}
